import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface HubEnterpriseConfig {
  authDomain: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private http = inject(HttpClient);

  config: HubEnterpriseConfig | undefined;

  async loadConfig(): Promise<HubEnterpriseConfig> {
    const response = await this.http.get<HubEnterpriseConfig>('/config').toPromise();
    this.config = response;
    return response as HubEnterpriseConfig;
  }

  private getConfig(): HubEnterpriseConfig | undefined {
    if (!this.config) {
      console.error('config could not be loaded from app config service.');
    }
    return this.config as HubEnterpriseConfig;
  }

  get authDomain(): string | undefined {
    return this.getConfig()?.authDomain;
  }
}
